<template>
  <div>
    <div>
      <!-- 导航栏 -->
      <Header
        v-if="this.identity !== ''"
        :activeIndex="activeIndex"
        :userName="userName"
        :identity="identity"
        :teacherGroup="teacherGroup"
      />
      <!-- 正文内容 -->
      <div style="width: 60%; margin-left: 20%; display: flex">
        <div
          style="
            margin-top: 15px;
            width: 200px;
            height: 530px;
            border: 1px solid #999;
          "
        >
          <div
            style="
              margin: -1px 0 0 -10px;
              width: 220px;
              height: 60px;
              background: #999;
              text-align: center;
              line-height: 60px;
            "
          >
            <img src="" alt="" />
            <span style="color: #fff; font-size: 20px">我的听说</span>
          </div>
          <!-- 侧边导航栏 -->
          <el-menu
            default-active="1"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
          >
            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span>个人中心</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="1" id="tab1" @click="myclick(1)"
                  >个人信息</el-menu-item
                >
                <el-menu-item index="2" id="tab2" @click="myclick(2)"
                  >修改密码</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </div>
        <!-- 个人信息 -->
        <div
          style="margin: 15px 0 0 50px; display: block"
          class="tab_css"
          id="tab1_content"
        >
          <div
            style="
              width: 780px;
              height: 60px;
              line-height: 50px;
              background: #999;
              border: 1px solid #ddd;
              color: #fff;
              font-size: 20px;
            "
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| 个人信息
          </div>
          <div
            style="
              width: 780px;
              height: 470px;
              background: #fff;
              border: 1px solid #ddd;
              border-top: 0;
            "
          >
            <table></table>
            <!--防止父元素高度坍塌 -->
            <div style="margin: 20px 0 25px 85px; color: #333; font-size: 18px">
              用户信息：
            </div>
            <div style="margin: 40px 0 5px 165px; color: #555">
              <div class="cover">
                <span class="user_info">用户名：</span>
                <el-input
                  placeholder="请输入内容"
                  v-model="input1"
                  :disabled="true"
                ></el-input>
                <el-button class="btn1" style="border: 0"></el-button>
              </div>
              <div class="cover">
                <span class="user_info">昵 称：</span>
                <el-input
                  placeholder="请输入内容"
                  v-model="input2"
                  :disabled="input_disabled1"
                  @input="valueChange"
                ></el-input>
                <el-button class="btn1" @click="change(1)">修改</el-button>
              </div>
              <div class="cover">
                <span class="user_info">邮 箱：</span>
                <el-input
                  placeholder="请输入内容"
                  v-model="input3"
                  :disabled="input_disabled2"
                  @input="valueChange"
                ></el-input>
                <el-button class="btn1" @click="change(2)">修改</el-button>
              </div>
              <div class="cover">
                <span class="user_info">手机号：</span>
                <el-input
                  placeholder="请输入内容"
                  v-model="input4"
                  :disabled="input_disabled3"
                  @input="valueChange"
                ></el-input>
                <el-button class="btn1" @click="change(3)">修改</el-button>
              </div>
              <div style="margin-left: 80px">
                <el-button
                  class="btn"
                  :disabled="btn_disabled"
                  type="primary"
                  @click="submit"
                  >提交</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <!-- 修改密码 -->
        <div
          style="margin: 15px 0 0 50px; display: none"
          class="tab_css"
          id="tab2_content"
        >
          <div
            style="
              width: 780px;
              height: 60px;
              line-height: 50px;
              background: #999;
              border: 1px solid #ddd;
              color: #fff;
              font-size: 20px;
            "
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| 修改密码
          </div>
          <div
            style="
              width: 780px;
              height: 470px;
              background: #fff;
              border: 1px solid #ddd;
              border-top: 0;
            "
          >
            <table></table>
            <!--防止父元素高度坍塌 -->
            <el-form
              :model="ruleForm"
              status-icon
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="旧密码" prop="oldPass">
                <el-input
                  type="password"
                  v-model="ruleForm.oldPass"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="newPass">
                <el-input
                  type="password"
                  v-model="ruleForm.newPass"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="确认新密码" prop="checkPass">
                <el-input
                  type="password"
                  v-model="ruleForm.checkPass"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="btn2"
                  type="primary"
                  @click="submitForm('ruleForm')"
                  >提交</el-button
                >
                <el-button class="btn2" @click="resetForm('ruleForm')"
                  >重置</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { home } from "@/api";
// import VDistpicker from "v-distpicker";
//引入token解析包 jwt-decode
import jwt_decode from "jwt-decode";
import Header from "./header.vue";

export default {
  // 省市区级联组件
  components: { Header },
  data() {
    var validateOldPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入旧密码"));
      } else {
        callback();
      }
    };
    var validateNewPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validateCheckPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.ruleForm.newPass) {
        callback(new Error("两次输入新密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      activeIndex: "user",
      identity: "",
      teacherGroup: 0,
      userName: "",
      tabPosition: "left",
      ruleForm: {
        oldPass: "",
        newPass: "",
        checkPass: "",
      },
      rules: {
        oldPass: [{ validator: validateOldPass, trigger: "blur" }],
        newPass: [{ validator: validateNewPass, trigger: "blur" }],
        checkPass: [{ validator: validateCheckPass, trigger: "blur" }],
      },
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      input_disabled1: true,
      input_disabled2: true,
      input_disabled3: true,
      btn_disabled: true,
      data: {
        nickname: "",
        email: "",
        phone: "",
      },
      num: 0,
    };
  },
  mounted() {
    this.init();
  },
  created() {},
  methods: {
    // 页面初始化的接口
    init() {
      // 获取token，并解析
      if (localStorage.getItem("token")) {
        let token = jwt_decode(localStorage.getItem("token"));
        // 获取用户信息（用户名和用户身份）
        this.identity = token.identity;
        this.teacherGroup = token.teacher_group;
        this.userName = token.nickname;
        home
          .getInfo()
          .then((res) => {
            if (res.data.retcode === 0) {
              this.input1 = res.data.data.username;
              this.input2 = res.data.data.nickname;
              this.input3 = res.data.data.email;
              this.input4 = res.data.data.phone;
              this.data.nickname = res.data.data.nickname;
              this.data.email = res.data.data.email;
              this.data.phone = res.data.data.phone;
            } else if (res.data.retcode === 1 || res.data.retcode === 2) {
              this.$alert(res.data.retmsg, "登录异常", {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.clearCache();
                },
              });
            } else {
              this.$alert(res.data.retmsg, "请求失败", {
                confirmButtonText: "确定",
                callback: (action) => {},
              });
            }
          })
          .catch((err) => {
            console.log(222);
          });
      } else {
        this.$message({
          message: "未登录，请重新登录",
          type: "warning",
          duration: 1000,
          onClose: (res) => {
            this.$router.push({ path: "/login" });
          },
        });
      }
    },
    handleOpen() {},
    handleClose() {},
    // tabs点击事件
    myclick(v) {
      var elems = $(".tab_css");
      for (var i = 0; i < elems.length; i++) {
        var elem = elems[i];
        if (elem == $("#tab" + v + "_content")[0]) {
          elem.style.display = "block";
        } else {
          elem.style.display = "none";
        }
      }
    },
    // 地址tab提交按钮--调接口传数据到后台
    submitAddress() {},

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            oldpassword: this.ruleForm.oldPass,
            newpassword: this.ruleForm.newPass,
          };
          home
            .submitUserPass(data)
            .then((res) => {
              if (res.data.retcode === 0) {
                this.$message({
                  message: "密码修改成功，请重新登录",
                  type: "success",
                  duration: 2000,
                  onClose: (res) => {
                    this.clearCache();
                  },
                });
              } else if (res.data.retcode === 1) {
                this.$message({
                  message: res.data.retmsg,
                  type: "warning",
                  duration: 2000,
                  onClose: (res) => {
                    this.clearCache();
                  },
                });
              } else {
                this.$message({
                  message: res.data.retmsg,
                  type: "warning",
                  duration: 2000,
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 输入框内容改变事件
    valueChange() {
      if (this.input2 === "" || this.input3 === "" || this.input4 === "") {
        this.btn_disabled = true;
      } else {
        this.btn_disabled = false;
      }
    },
    // 修改按钮点击事件
    change(val) {
      // this.btn_disabled = false;
      if (val === 1) {
        this.input_disabled1 = false;
      }
      if (val === 2) {
        this.input_disabled2 = false;
      }
      if (val === 3) {
        this.input_disabled3 = false;
      }
      if (this.input2 !== "" && this.input3 !== "" && this.input4 !== "") {
        this.btn_disabled = false;
      }
    },
    // 修改密码接口
    submit() {
      let reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      let reg1 = /^[1][3,4,5,7,8][0-9]{9}$/;
      let data = {};
      // 验证邮箱和手机号格式
      if (reg.test(this.input3) === false) {
        this.$message({
          message: "请输入正确的邮箱地址！",
          type: "error",
        });
      } else if (reg1.test(this.input4) === false) {
        this.$message({
          message: "请输入正确的手机号！",
          type: "error",
        });
      } else {
        if (
          this.input2 === this.data.nickname &&
          this.input3 === this.data.email &&
          this.input4 === this.data.phone
        ) {
          this.$message({
            message: "用户信息未做修改！",
            type: "error",
          });
        } else {
          if (this.input2 !== this.data.nickname) {
            data.nickname = this.input2;
            this.data.nickname = this.input2;
          }
          if (this.input3 !== this.data.email) {
            data.email = this.input3;
            this.data.email = this.input3;
          }
          if (this.input4 !== this.data.phone) {
            data.phone = this.input4;
            this.data.phone = this.input4;
          }
          home
            .change(data)
            .then((res) => {
              if (res.data.retcode === 0) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                  duration: 2000,
                  onClose: (res) => {
                    this.input_disabled1 = true;
                    this.input_disabled2 = true;
                    this.input_disabled3 = true;
                    this.btn_disabled = true;
                  },
                });
              } else if (res.data.retcode === 1 || res.data.retcode === 2) {
                this.$alert(res.data.retmsg, "登录异常", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    this.clearCache();
                  },
                });
              } else {
                this.$alert(res.data.retmsg, "请求失败", {
                  confirmButtonText: "确定",
                  callback: (action) => {},
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    //退出按钮点击事件---清空本地储存的token
    clearCache() {
      localStorage.removeItem("token"); //清空本地缓存的token
      this.$router.push({ path: "/login" });
    },
  },
};
</script>
<style scoped>
p {
  margin-bottom: 0;
}
.sidebar_ul {
  padding: 0;
}
.sidebar_ul li {
  list-style: none;
  width: 200px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  font-size: 15px;
  color: #777777;
  margin-top: 6px;
}
ul li:hover {
  color: #f00;
  background: #dddddd;
}
a {
  display: inline-block;
  width: 100%;
  height: 100%;
  text-decoration: none;
}
.one_t {
  margin-left: 122px;
  font-size: 14px;
  color: #f00;
  display: inline-block;
}
.demo-ruleForm {
  margin: 100px 0 0 150px;
  width: 50%;
}
.cover {
  display: flex;
  margin-bottom: 10px;
  width: 400px;
  height: 60px;
}
.cover span {
  width: 100px;
}
.btn {
  margin: 10px 20px 0 35px;
  width: 160px;
  height: 50px;
  font-size: 16px;
}
.btn1 {
  margin: 10px 0 0 20px;
  padding: 0;
  width: 70px;
  height: 20px;
  color: #f00;
}
.btn2 {
  margin-left: 45px;
}
.user_info {
  display: inline-block;
  padding-top: 8px;
}
</style>
<style>
.distpicker-address-wrapper select {
  padding: 0;
  width: 100px;
  height: 25px;
}
</style>
